import React from 'react';
import CategoriesComponent from '../components/categories';
import SEO from '../components/seo';

const Categories = () => {
  return (
    <>
      <SEO
        title="Categories"
        description="Browse all categories"
      />
      <CategoriesComponent />
    </>
  );
};

export default Categories;